/* istanbul ignore file */
import instance, { bffUrl } from '../service.parameters';

export const getSimpleAccountDetails = async accountNumber => {
  const url = await bffUrl();

  return instance.get(`${url}simple-accounts/${accountNumber}/current`);
};
